import React, { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Typography } from '@material-ui/core';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import AlertDialog from '../../../../../../components/AlertDialog/index.es6';
import { numberInCommaFormat } from '../../../../../../lib/access.es6';
import { getNuclearPremium, getNuclearBenefit } from '../../../../PolicyAdmin/helpers/index';
import { white } from 'material-ui/styles/colors';

/**
 * Modal for selecting a parent plan (lower tier than nuclear plan)
 */
const PlanSelectionModal = ({ show, onClose, onSelectPlan, plans, nuclearPlan, coverType }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const handleConfirm = () => {
    if (selectedPlan) {
      onSelectPlan(selectedPlan);
      setSelectedPlan(null);
    }
  };

  const handleCancel = () => {
    setSelectedPlan(null);
    onClose();
  };

  // Filter plans: only show plans with rank lower than nuclear plan
  const nuclearRank = nuclearPlan ? parseInt(nuclearPlan.name.split(" ")[1]) : 0;
  const updatedPlans = plans.map((plan) => {
    const rank = parseInt(plan.name.split(" ")[1]);
    return { ...plan, rank };
  });
  const filteredPlans = updatedPlans.filter(plan => plan.rank < nuclearRank);

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(4, filteredPlans.length),
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, filteredPlans.length),
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, filteredPlans.length),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <AlertDialog
      custom
      show={show}
      onClose={handleCancel}
      size="lg"
      showCancel={false}
      showConfirm={false}
      showTitle={false}
      style={{ marginTop: '0', top: '50%', transform: 'translateY(-50%)' }}
    >
      <div style={{ padding: '25px' }}>
        <Typography variant="h5" gutterBottom style={{ marginBottom: '10px', textAlign: 'center', color: '#032A37', fontWeight: 'bold' }}>
          Select Parent Plan
        </Typography>
        <p style={{ marginBottom: '20px', color: '#666', textAlign: 'center' }}>
          Select a plan for parent members. Only plans lower than your current nuclear plan (Plan {nuclearRank}) are available.
        </p>

        {filteredPlans.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            No lower-tier plans available. Your nuclear plan is already the lowest tier.
          </div>
        ) : (
          <div style={{ background: 'light grey', padding: '2%', marginBottom: '20px' }}>
            <Slider {...sliderSettings}>
              {filteredPlans.map((plan, index) => (
                <div key={index}>
                  <div
                    onClick={() => handleSelect(plan)}
                    style={{
                      color: (selectedPlan && selectedPlan.name === plan.name) ? white : '#bdbdbd',
                      fontSize: 20,
                      borderRadius: '10%',
                      transition: 'all 0.3s ease-in-out',
                      cursor: 'pointer',
                      background: (selectedPlan && selectedPlan.name === plan.name) ? 'orange' : '#032a37',
                      margin: '3%',
                      textAlign: 'center',
                      padding: '10px'
                    }}
                  >
                    <div style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>{plan.name}</div>
                    <hr style={{ margin: '10px 0' }} />
                    <div>Premium: {numberInCommaFormat(getNuclearPremium(plan, coverType) / 100)}</div>
                    <div>Benefit: {numberInCommaFormat(getNuclearBenefit(plan) / 100)}</div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
          <ButtonInc
            btnType="secondary"
            onClick={handleCancel}
            style={{ border: '1px solid #032A37' }}
          >
            Cancel
          </ButtonInc>
          <ButtonInc
            onClick={handleConfirm}
            disabled={!selectedPlan}
            style={{
              background: selectedPlan ? '#032A37' : '#ccc',
              opacity: selectedPlan ? 1 : 0.6
            }}
          >
            Select Plan
          </ButtonInc>
        </div>
      </div>
    </AlertDialog>
  );
};

export default PlanSelectionModal;
